import {
    BOOKINGREQUEST_LIST,
    BOOKINGREQUEST_PAGINATION,
    BOOKINGREQUEST_SUMMARY,
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';
import { callLoader } from '../Loader/actions';
import { ca } from 'date-fns/locale';


/**
 * getExpBKGReqList
 * @param {*} payload 
 * @returns 
 */
export const getExpBKGReqList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({
                ...payload,
            }).toString();
            const url = `v1/ExportBookingRequest/GetExpBKGReqList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: BOOKINGREQUEST_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: BOOKINGREQUEST_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    dispatch({
                        type: BOOKINGREQUEST_SUMMARY,
                        payload: result?.summary || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);

        } finally {
            dispatch(callLoader(false));
        }

    };
};

/**
 * getExpBKGReqCancelledList
 * @param {*} payload 
 * @returns 
 */
export const getExpBKGReqCancelledList = (payload) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const queryParams = new URLSearchParams({
                ...payload,
            }).toString();
            const url = `v1/ExportBookingRequest/GetExpBKGReqCancelledList?${queryParams}`;
            return APICall('get', payload, url).then(result => {
                dispatch(callLoader(false));
                if (result?.statuscode === 200 || result?.statuscode === '201') {
                    dispatch({
                        type: BOOKINGREQUEST_LIST,
                        payload: result?.data || [],
                    });
                    dispatch({
                        type: BOOKINGREQUEST_PAGINATION,
                        payload: result?.pagination || {},
                    });
                    dispatch({
                        type: BOOKINGREQUEST_SUMMARY,
                        payload: result?.summary || {},
                    });
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            dispatch(callLoader(false));
            return Promise.reject(error);

        } finally {
            dispatch(callLoader(false));
        }
    };
};

/**
 * getExpBookingRequestById
 * @param {*} payload 
 * @returns 
 */
export const getExpBookingRequestById = (payload, CompanyId) => {
    return dispatch => {
        try {
            dispatch(callLoader(true));
            const url = `v1/ExportBookingRequest/GetExpBookingRequestById?BkgReqId=${payload}&CompanyId=${CompanyId}`;
            return APICall('get', payload, url).then(result => {
                if (result?.statuscode === 200) {
                    return result?.data;
                } else {
                    return Promise.reject();
                }
            }, error => {
                return Promise.reject(error);
            });
        } catch (error) {
            console.log(error);
            return Promise.reject(error);
        } finally {
            dispatch(callLoader(false));
        }
    };
};

/**
 * createExportBookingRequest
 * @param {*} payload 
 * @returns 
 */
export const createExportBookingRequest = (payload) => {
    try {
        const url = `v1/ExportBookingRequest/CreateExportBookingRequest`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * updateExportBookingRequest
 * @param {*} payload 
 * @returns 
 */
export const updateExportBookingRequest = async (payload) => {
    try {
        const url = `v1/ExportBookingRequest/UpdateExportBookingRequest`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * deleteExpBookingRequestList
 * @param {*} payload 
 * @returns 
 */
export const deleteExpBookingRequestList = (payload) => {
    const url = `v1/ExportBookingRequest/DeleteExpBookingRequestList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};

/**
 * reinstateBookingRequestList
 * @param {*} payload 
 * @returns 
 */
export const reinstateBookingRequestList = (payload) => {
    const url = `v1/ExportBookingRequest/ReinstateBookingRequestList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};

/**
 * getBookingRequestNotes
 * @param {*} payload 
 * @returns 
 */
export const getBookingRequestNotes = async (payload) => {
    try {
        const url = `v1/ExportBookingRequest/GetBookingRequestNotes?BkgReqId=${payload}&CompanyId=${setAuthToken()?.userData?.CompanyId}`;
        return APICall('get', payload, url).then(async result => {
            if (result?.statuscode === 200) {
                return result;
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};

/**
 * insertBookingRequestNotes
 * @param {*} payload 
 * @returns 
 */
export const insertBookingRequestNotes = async (payload) => {
    try {
        const url = `v1/ExportBookingRequest/InsertBookingRequestNotes`;
        return APICall('post', payload, url).then(async result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return getBookingRequestNotes(payload?.RateQuoteId);
            } else {
                return false;
            }
        });
    } catch (error) {
        console.log(error);
        return error;
    } finally {
    }
};
